const ur = `${import.meta.env.VITE_API_URL}`
const l = `${import.meta?.env?.VITE_API_PORT ?? ''}`

let uuu = ur;
if(l.length > 0) uuu+=":"+l;

console.log("URL",uuu)
export default uuu